import React from 'react';
import { Moment } from 'moment';

interface IFormattedDateTimeProps {
	value: Moment;
	format: string;
}

export const FormattedDateTime = ({
	value,
	format,
}: IFormattedDateTimeProps) => <>{value.format(format)}</>;
